module.exports = __webpack_public_path__ + "citrus-segment.png?d98f031ab4a7841fd925c3e7aef284fd";


//////////////////
// WEBPACK FOOTER
// ./static/citrus-segment.png
// module id = 546
// module chunks = 0